import {apiConfig} from '@stencil/hotels-config';

export default function prepareSnapshotUrl(hotelId, idf, val) {
  let url = `${apiConfig.__UGC__}/api/Hotels/snapshotv2?vid=${hotelId}`;
  if (!!idf && !!val) url += `&idf=${idf}&val=${val}`;
  return url;
}
